import { render, staticRenderFns } from "./WarningblockAudio.vue?vue&type=template&id=69f5640e&scoped=true&"
import script from "./WarningblockAudio.vue?vue&type=script&lang=js&"
export * from "./WarningblockAudio.vue?vue&type=script&lang=js&"
import style0 from "./WarningblockAudio.vue?vue&type=style&index=0&id=69f5640e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f5640e",
  null
  
)

export default component.exports